import { render, staticRenderFns } from "./MomentForm.vue?vue&type=template&id=9a6de912&scoped=true"
import script from "./MomentForm.vue?vue&type=script&lang=js"
export * from "./MomentForm.vue?vue&type=script&lang=js"
import style0 from "./MomentForm.vue?vue&type=style&index=0&id=9a6de912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6de912",
  null
  
)

export default component.exports